export default __webpack_public_path__ + "static/superhuman-ai-97e9d5dd740fa94978484f667fad1f91.webp";